let newArr = []
export function dealArr(arr) {
    arr = arr.splice(1,arr.length-1)
    let arr1 = JSON.stringify(arr)
    newArr.push(JSON.parse(arr1))
    if(arr.length>0){
        dealArr(arr)
    }
    return newArr
}
export function dealArrMaxNum(arr){
    var newArr=[];
    for(var i=0;i<arr.length;i++){
        if(arr[i].length>0){
            newArr.push(Math.max.apply(Math,arr[i]));
        }else{
            newArr.push(-1);
        }
    }
    return newArr;
}

// let printArr = dealArrMaxNum(dealArr(arr))
// console.log(printArr)
